import Carousel from 'react-bootstrap/Carousel';
import Image from 'react-bootstrap/Image';

import Picture from '../assets/pictures/moi-black-white.jpg';
import Drums from '../assets/pictures/drums.webp';
import Guitar from '../assets/pictures/guitar.webp';
import Piano from '../assets/pictures/piano.webp';
import Clarinet from '../assets/pictures/clarinet.webp';
import PythonLogo from '../assets/pictures/python-logo.png';
import CLogo from '../assets/pictures/c-logo.png';
import CPlusPlusLogo from '../assets/pictures/cplusplus-logo.png';
import DjangoLogo from '../assets/pictures/django-logo.png';
import FlaskLogo from '../assets/pictures/flask-logo.png';
import FastApiLogo from '../assets/pictures/fastapi-logo.png';
import ReactLogo from '../assets/pictures/react-logo.png';
import VueLogo from '../assets/pictures/vue-logo.png';
import AngularLogo from '../assets/pictures/angular-logo.png';
import DockerLogo from '../assets/pictures/docker-logo.png';

import Container from 'react-bootstrap/esm/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import CardGroup from 'react-bootstrap/CardGroup';
import ProgressBar from 'react-bootstrap/ProgressBar';

import '../utils/general.css';
import '../utils/home.css';

import enTranslations from '../locales/en.json';
import frTranslations from '../locales/fr.json';

import { useLanguage } from '../components/languageContext'; // Importez le hook useLanguage


function Home() {
  const { language } = useLanguage();

  const translations = language === 'en' ? enTranslations : frTranslations;

  const forty = 40;
  const fortyFive = 45;
  const fifty = 50;
  const fiftyFive = 55;
  const sixty = 60;
  const sixtyFive = 65;
  const seventy = 70;
  const seventyFive = 75;

  return (
    <Container className='ps-home vertical-center mt-4 mb-5' fluid>
      <Row className='ps-row mb-5 mt-5'>
        <Col lg={6} className="text-center align-self-center pt-5">
          <Image
            src={Picture}
            roundedCircle
            alt="profil picture"
            style={{
              maxWidth: "500px",
              width: "100%",
              height: "auto"
            }}
          />
        </Col>
        <Col  lg={6} className='text-center align-self-center'>
          <Row className='ps-profil-title'>
            <h1>Pierre Saumet</h1>
            <h2>{translations.home.titre}</h2>
          </Row>
          <Row className='ps-profil-description'>
            <p>
              {translations.home.intro}
            </p>
            <p>
              {translations.home.intro2}
            </p>
            <Carousel>
              <Carousel.Item>
                <Image src={Drums} alt="drums picture by Michael Dobrinski" rounded className='ps-profil-carousel-picture'/>
                <Carousel.Caption>
                  <p style={{ color: 'white' }}><small>{translations.home.drums}</small></p>
                </Carousel.Caption>
              </Carousel.Item>
              <Carousel.Item>
                <Image src={Guitar} alt="guitar picture by Vincet Nicolas" rounded className='ps-profil-carousel-picture'/>
                <Carousel.Caption>
                  <p style={{ color: 'white' }}><small>{translations.home.guitar}</small></p>
                </Carousel.Caption>
             </Carousel.Item>
             <Carousel.Item>
                <Image src={Piano} alt="piano picture by David Pisnoy" rounded className='ps-profil-carousel-picture'/>
                <Carousel.Caption>
                  <p style={{ color: 'white' }}><small>{translations.home.piano}</small></p>
                </Carousel.Caption>
             </Carousel.Item>
             <Carousel.Item>
                <Image src={Clarinet} alt="clarinet picture by Adam Cai" rounded className='ps-profil-carousel-picture'/>
                <Carousel.Caption>
                  <p style={{ color: 'white' }}><small>{translations.home.clarinet}</small></p>
                </Carousel.Caption>
             </Carousel.Item>
            </Carousel>
          </Row>
        </Col>
        <Col className='ps-profil-techno text-center align-self-center' style={{ marginTop: "5em" }}>
          <Row>
            <h1 className='title'>
              {translations.home.skills.title}
            </h1>
          </Row>
          <Row>
            <CardGroup className='ps-card'>
              <Card>
                <Card.Img variant="top" src={PythonLogo} style={{ maxWidth: '100px'}} className='mx-auto'/>
                <Card.Body>
                  <Card.Title>Python</Card.Title>
                  <Card.Text>
                    {translations.home.skills.python}
                  </Card.Text>
                </Card.Body>
                <Card.Footer>
                  <ProgressBar variant="primary" now={seventyFive} label={`${seventyFive}%`} animated/>
                </Card.Footer>
              </Card>
              <Card>
                <Card.Img variant="top" src={DjangoLogo} style={{ maxWidth: '100px'}} className='mx-auto'/>
                <Card.Body>
                  <Card.Title>Django</Card.Title>
                  <Card.Text>
                    {translations.home.skills.django}
                  </Card.Text>
                </Card.Body>
                <Card.Footer>
                  <ProgressBar variant="primary" now={seventy} label={`${seventy}%`} animated/>
                </Card.Footer>
              </Card>
              <Card>
                <Card.Img variant="top" src={FlaskLogo} style={{ maxWidth: '100px'}} className='mx-auto'/>
                <Card.Body>
                  <Card.Title>Flask</Card.Title>
                  <Card.Text>
                    {translations.home.skills.flask}
                  </Card.Text>
                </Card.Body>
                <Card.Footer>
                <ProgressBar variant="success" now={fifty} label={`${fifty}%`} animated/>
                </Card.Footer>
              </Card>
            </CardGroup>
          </Row>
          <Row>
            <CardGroup className='ps-card'>
              <Card>
                <Card.Img variant="top" src={FastApiLogo} style={{ maxWidth: '100px'}} className='mx-auto'/>
                <Card.Body>
                  <Card.Title>FastAPI</Card.Title>
                  <Card.Text>
                    {translations.home.skills.fastapi}
                  </Card.Text>
                </Card.Body>
                <Card.Footer>
                <ProgressBar variant="success" now={sixty} label={`${sixty}%`} animated/>
                </Card.Footer>
              </Card>
              <Card>
                <Card.Img variant="top" src={VueLogo} style={{ maxWidth: '100px'}} className='mx-auto'/>
                <Card.Body>
                  <Card.Title>Vue</Card.Title>
                  <Card.Text>
                    {translations.home.skills.vue}
                  </Card.Text>
                </Card.Body>
                <Card.Footer>
                <ProgressBar variant="success" now={fiftyFive} label={`${fiftyFive}%`} animated/>
                </Card.Footer>
              </Card>
              <Card>
                <Card.Img variant="top" src={ReactLogo} style={{ maxWidth: '100px'}} className='mx-auto'/>
                <Card.Body>
                  <Card.Title>React</Card.Title>
                  <Card.Text>
                    {translations.home.skills.react}
                  </Card.Text>
                </Card.Body>
                <Card.Footer>
                <ProgressBar variant="primary" now={sixtyFive} label={`${sixtyFive}%`} animated/>
                </Card.Footer>
              </Card>
            </CardGroup>
          </Row>
          <Row>
            <CardGroup className='ps-card'>
              <Card>
                <Card.Img variant="top" src={AngularLogo} style={{ maxWidth: '100px'}} className='mx-auto'/>
                <Card.Body>
                  <Card.Title>Angular</Card.Title>
                  <Card.Text>
                    {translations.home.skills.angular}
                  </Card.Text>
                </Card.Body>
                <Card.Footer>
                  <ProgressBar variant="warning" now={fortyFive} label={`${fortyFive}%`} animated/>
                </Card.Footer>
              </Card>
              <Card>
                <Card.Img variant="top" src={CLogo} style={{ maxWidth: '100px'}} className='mx-auto'/>
                <Card.Body>
                  <Card.Title>C</Card.Title>
                  <Card.Text>
                  {translations.home.skills.c}
                  </Card.Text>
                </Card.Body>
                <Card.Footer>
                <ProgressBar variant="danger" now={forty} label={`${forty}%`} animated/>
                </Card.Footer>
              </Card>
              <Card>
                <Card.Img variant="top" src={CPlusPlusLogo} style={{ maxWidth: '100px'}} className='mx-auto'/>
                <Card.Body>
                  <Card.Title>C++</Card.Title>
                  <Card.Text>
                  {translations.home.skills.cplusplus}
                  </Card.Text>
                </Card.Body>
                <Card.Footer>
                <ProgressBar variant="warning" now={fifty} label={`${fifty}%`} animated/>
                </Card.Footer>
              </Card>
            </CardGroup>
          </Row>
          <Row>
            <CardGroup className='ps-card'>
              <Card>
                <Card.Img variant="top" src={DockerLogo} style={{ maxWidth: '100px'}} className='mx-auto'/>
                <Card.Body>
                  <Card.Title>Docker</Card.Title>
                  <Card.Text>
                    {translations.home.skills.docker}
                  </Card.Text>
                </Card.Body>
                <Card.Footer>
                <ProgressBar variant="success" now={sixty} label={`${sixty}%`} animated/>
                </Card.Footer>
              </Card>
            </CardGroup>
          </Row>
        </Col>
      </Row>
    </Container>
  );
}

export default Home;
